<div class="w-full" *ngIf="selectedSearchOption === 0">
  <form [formGroup]="filterForm_dynamic" (ngSubmit)="search()">
    <div class="w-full flex flex-wrap py-2 justify-between gap-2">
      <!-- Launching Status -->
      <div
        class="lg:w-[32%] w-full bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-md"
      >
        <h1 class="text-[#388e3c] text-xs mb-2">Launching Status</h1>
        <p-dropdown
          formControlName="launchingStatus"
          [options]="dynamicFields.launchStatus"
          [filter]="true"
          filterPlaceholder="Search Launching Status"
          class="w-full"
          (onChange)="onDropdownChange('launchStatus', $event)"
          placeholder="Enter Your Launching Status"
        >
          <ng-template let-option pTemplate="item">
            <span>{{ truncateName(option, 5) }}</span>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Year Wise off Patent Molecule -->
      <div
        class="lg:w-[32%] w-full bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-md mb-2"
      >
        <h1 class="text-[#388e3c] text-xs mb-2">
          Year Wise off Patent Molecule
        </h1>
        <p-dropdown
          formControlName="yearWiseOffPatentMolecule"
          [options]="dynamicFields.yearWiseOffPatentMolecules"
          [filter]="true"
          filterPlaceholder="Search Year Wise off Patent Molecule"
          class="w-full"
          (onChange)="
            onDropdownChange('yearWiseOffPatentMolecules', $event)
          "
          placeholder="Enter Your Year Wise off Patent Molecule"
        >
          <ng-template let-option pTemplate="item">
            <span>{{ option }}</span>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Launching Year -->
      <div
        class="lg:w-[32%] w-full bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-md mb-2"
      >
        <h1 class="text-[#388e3c] text-xs mb-2">Launching Year</h1>
        <p-dropdown
          formControlName="launchingYear"
          [options]="dynamicFields.launchingYear"
          [filter]="true"
          filterPlaceholder="Search Launching Year"
          class="w-full"
          (onChange)="onDropdownChange('launchingYear', $event)"
          placeholder="Enter Your Launching Year"
        >
          <ng-template let-option pTemplate="item">
            <span>{{ option }}</span>
          </ng-template>
        </p-dropdown>
      </div>

      <!-- Search Categories -->
      <div
        class="lg:w-[32%] w-full bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-md mb-2"
      >
        <h1 class="text-[#388e3c] text-xs mb-2">
          Off Patent Active Ingredient
        </h1>
        <div
          class="bg-[#F8FAFF] py-2 px-3 text-gray-600 rounded-md cursor-default -ml-4"
          title="Generic Constraining Date"
        >
          Generic Constraining Date
        </div>
      </div>

      <!-- Start Date -->
      <div
        class="lg:w-[32%] w-full bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-md mb-2"
      >
        <h1 class="text-[#388e3c] text-xs mb-2">Start Date</h1>
        <input
          formControlName="startDate"
          type="date"
          class="w-full max-w-[160px] bg-transparent text-sm text-gray-500 font-semibold focus:outline-none cursor-pointer border-none"
        />
      </div>

      <!-- End Date -->
      <div
        class="lg:w-[32%] w-full bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-md mb-2"
      >
        <h1 class="text-[#388e3c] text-xs mb-2">End Date</h1>
        <input
          formControlName="endDate"
          type="date"
          class="w-full max-w-[160px] bg-transparent text-sm text-gray-500 font-semibold focus:outline-none cursor-pointer"
        />
      </div>

      <!-- Year of Discovery and Property / Generic in one row with 50% width each -->
      <div class="flex w-full gap-4 mb-3">
        <!-- Year of Discovery (50%) -->
        <div
          class="w-1/2 bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-l-md"
        >
          <h1 class="text-[#388e3c] text-xs mb-2">Year of Discovery</h1>
          <p-dropdown
            formControlName="yearOfDiscovery"
            [options]="dynamicFields.yearOfDiscovery"
            [filter]="true"
            filterPlaceholder="Search Year of Discovery"
            class="w-full"
            (onChange)="onDropdownChange('yearOfDiscovery', $event)"
            placeholder="Enter Your Year of Discovery"
          >
            <ng-template let-option pTemplate="item">
              <span>{{ truncateName(option, 5) }}</span>
            </ng-template>
          </p-dropdown>
        </div>

        <!-- Property / Generic (50%) -->
        <div
          class="w-1/2 bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-r-md"
        >
          <h1 class="text-[#388e3c] text-xs mb-2">Select Property / Generic</h1>
          <p-dropdown
            formControlName="propertyGeneric"
            [options]="dynamicFields.genericPropDevCadateWdrw"
            [filter]="true"
            filterPlaceholder="Search Property / Generic"
            class="w-full"
            (onChange)="onDropdownChange('propertyGeneric', $event)"
            placeholder="Enter Your Property / Generic"
          >
            <ng-template let-option pTemplate="item">
              <span>{{ truncateName(option, 5) }}</span>
            </ng-template>
          </p-dropdown>
        </div>
        <!-- ISO Publication (50%) -->

        <div
          class="w-1/2 bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-r-md"
        >
          <h1 class="text-[#388e3c] text-xs mb-2">Select ISO Publication</h1>
          <p-dropdown
            formControlName="isoPublication"
            [options]="dynamicFields.isoPublication"
            [filter]="true"
            filterPlaceholder="Search ISO Publication"
            class="w-full"
            (onChange)="onDropdownChange('isoPublication', $event)"
            placeholder="Enter Your ISO Publication"
            optionLabel="label"
          >
            <ng-template let-option pTemplate="item">
              <span>{{ option.label }}</span>
              <!-- Display the label in the dropdown -->
            </ng-template>
          </p-dropdown>
        </div>
      </div>

      <!-- ISO Publication and Innovator in one row with 50% width each -->
      <div class="flex w-full gap-4 mb-2">
        <!-- Innovator (50%) -->

        <div
          class="w-1/2 bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-r-md"
        >
          <h1 class="text-[#388e3c] text-xs mb-2">Innovator (Originator)</h1>
          <p-dropdown
            formControlName="innovator"
            [options]="dynamicFields.notes"
            [filter]="true"
            filterPlaceholder="Search Innovator"
            class="w-full"
            (onChange)="onDropdownChange('innovator', $event)"
            placeholder="Enter Your Innovator (Originator)"
          >
            <ng-template let-option pTemplate="item">
              <span>{{ truncateName(option, 5) }}</span>
            </ng-template>
          </p-dropdown>
        </div>
        <div
          class="w-1/2 bg-[#F8FAFF] border py-3 px-3 border-gray-300 rounded-r-md"
        >
          <h1 class="text-[#388e3c] text-xs mb-2">
            Innovator (Originator) Country
          </h1>
          <p-dropdown
            formControlName="InnovatorCountry"
            [options]="dynamicFields.dummy1"
            [filter]="true"
            filterPlaceholder="Search Innovator(Originator) Country"
            class="w-full"
            (onChange)="onDropdownChange('InnovatorCountry', $event)"
            placeholder="Enter Innovator (Originator) Country"
          >
            <ng-template let-option pTemplate="item">
              <span>
                {{ truncateName(option, 5) }}
              </span>
            </ng-template>
          </p-dropdown>
        </div>
      </div>
    </div>

    <!-- Explore More With Tutorials and Submit/Reset buttons -->
    <div class="flex flex-wrap justify-between gap-4 py-4">
      <button
        type="button"
        class="px-6 py-3 bg-[#FFCD04] rounded-lg font-semibold text-[#303027] text-[16px] leading-[20px] flex items-center justify-between cursor-pointer w-auto min-w-[280px] md:min-w-[400px] lg:min-w-[430px]"
        (click)="showVideoModal()"
      >
        <div>Explore More With Tutorials</div>
        <img
          src="../../../assets/icons/Video.png"
          alt="YouTube"
          class="w-6 h-6"
        />
      </button>

      <p-dialog
        header="Tutorial Video"
        [(visible)]="displayVideoModal"
        [modal]="true"
        [responsive]="true"
        [style]="{ width: '80vw' }"
      >
        <iframe
          *ngIf="videoUrl"
          [src]="videoUrl"
          width="100%"
          height="400"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </p-dialog>

      <div class="mt-3 flex justify-end gap-4 w-full lg:w-[30%] md:w-[45%]">
        <button
          type="submit"
          class="flex-grow px-4 py-3 text-[15px] leading-[18.29px] font-semibold rounded-full transition-all duration-300"
          style="
            background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
            color: rgb(255, 237, 141);
          "
          onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
          onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';"
        >
          Search
        </button>

        <button
          type="button"
          class="flex-grow border-2 px-4 py-3 text-[15px] leading-[18.29px] border-[#388e3c] font-semibold text-[#388e3c] rounded-full"
          (click)="resetallform()"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</div>
<!-- Alert Dialogs if user not have privilege -->
<!-- Search Privilege dialog -->
<p-dialog
  header="Search Privilege"
  [(visible)]="is_show_Search_Priv_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't have permission to Search, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Daily Search Exceed dialog -->
<p-dialog
  header="Daily Search Exceed"
  [(visible)]="is_show_Daily_Search_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily search limit, please contact the support team
      at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Total Search Exceed  dialog -->
<p-dialog
  header="Total Search Exceed"
  [(visible)]="is_show_Total_Search_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your search count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Download  Privilege dialog -->
<p-dialog
  header="Download Privilege"
  [(visible)]="is_show_Download_Priv_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't permission to download, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Daily Download Exceed dialog -->
<p-dialog
  header="Daily Download Exceed"
  [(visible)]="is_show_Daily_Download_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily download limit, please contact the support
      team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Total Downalod Exceed  dialog -->
<p-dialog
  header="Total Download Exceed "
  [(visible)]="is_show_Total_Download_Exceed_popup"
  [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '25vw', padding: '0px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your download count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>
